import { StageEvent } from '../../message/index';
import FrontCubeData from '../../frontCubeData/index';
import Select from '../select/index';
import NextTick from '../../utils/nextTick';
import History from '../history/index';
import { cubeModify } from '../../update/cubeModify';
import { updateCubeList } from '../../update/updateCubeList';
import { updateEnd } from '../../update/updateEnd';
import { makeUpdateTaskQueue, findUpdateTargets } from './toolkit';

function changeSurface(cubes: Array<CubeId>, surface: number): void {
    let updateList: CubeId[] = findUpdateTargets(cubes);
    let oldSurfaceInfo: UpdateTask[] = makeOldSurfaceInfo(cubes);

    History.stackIn({
        type: 'quickSurface',
        data: oldSurfaceInfo
    });
    cubes.forEach((cubeId: CubeId): void => {
        cubeModify(cubeId, {
            surfaceWidth: surface
        });
    });
    updateCubeList(updateList);
    updateEnd();
}

function makeOldSurfaceInfo(cubeIds: CubeId[]): UpdateTask[] {
    let result: UpdateTask[] = [];

    cubeIds.forEach((cubeId: CubeId): void => {
        let oldSurfaceWidth: number = FrontCubeData.getNumberValue(cubeId, 'surfaceWidth');

        result.push({
            cubeId,
            updateData: {
                surfaceWidth: oldSurfaceWidth
            }
        });
    });

    return result;
}

function changeAllSelectedSurface(surface: number): void {
    if (surface <= 0) {
        return;
    }

    let selectedGoods: Array<CubeId> = Select.getSelectedByType('goods');

    changeSurface(selectedGoods, surface);
}

export {
    changeAllSelectedSurface
};
